<template>
  <div class="partner_body">
    <!-- <div class="row">
      <div>
        <a><img src="../../../assets/images/partnerlogo/1.png"></a>
      </div>
      <div style="padding-left: 65px">
        <a><img src="../../../assets/images/partnerlogo/2.png"></a>
      </div>
      <div style="padding-left: 64px">
        <a><img src="../../../assets/images/partnerlogo/3.png"></a>
      </div>
      <div style="padding-left: 65px">
        <a><img src="../../../assets/images/partnerlogo/4.png"></a>
      </div>
      <div style="padding-left: 65px">
        <a><img src="../../../assets/images/partnerlogo/5.png"></a>
      </div>
      <div style="padding-left: 64px">
        <a><img src="../../../assets/images/partnerlogo/6.png"></a>
      </div>
      <div style="padding-left: 64px">
        <a><img src="../../../assets/images/partnerlogo/7.png"></a>
      </div>
    </div> -->
    <!-- <div class="row part_top_padding">
      <div>
        <a><img src="../../../assets/images/partnerlogo/8.png"></a>
      </div>
      <div style="padding-left: 65px">
        <a><img src="../../../assets/images/partnerlogo/9.png"></a>
      </div>
      <div style="padding-left: 64px">
        <a><img src="../../../assets/images/partnerlogo/10.png"></a>
      </div>
      <div style="padding-left: 65px">
        <a><img src="../../../assets/images/partnerlogo/11.png"></a>
      </div>
      <div style="padding-left: 65px">
        <a><img src="../../../assets/images/partnerlogo/12.png"></a>
      </div>
      <div style="padding-left: 64px">
        <a><img src="../../../assets/images/partnerlogo/13.png"></a>
      </div>
      <div style="padding-left: 64px">
        <a><img src="../../../assets/images/partnerlogo/14.png"></a>
      </div>
    </div> -->
    <!-- <div class="row part_top_padding">
      <div>
        <a><img src="../../../assets/images/partnerlogo/15.png"></a>
      </div>
      <div style="padding-left: 65px">
        <a><img src="../../../assets/images/partnerlogo/16.png"></a>
      </div>
      <div style="padding-left: 64px">
        <a><img src="../../../assets/images/partnerlogo/17.png"></a>
      </div>
      <div style="padding-left: 65px">
        <a><img src="../../../assets/images/partnerlogo/18.png"></a>
      </div>
      <div style="padding-left: 65px">
        <a><img src="../../../assets/images/partnerlogo/19.png"></a>
      </div>
      <div style="padding-left: 64px">
        <a><img src="../../../assets/images/partnerlogo/20.png"></a>
      </div>
      <div style="padding-left: 64px">
        <a><img src="../../../assets/images/partnerlogo/21.png"></a>
      </div>
    </div> -->
    <!-- <div class="row part_top_padding">
      <div>
        <a><img src="../../../assets/images/partnerlogo/22.png"></a>
      </div>
      <div style="padding-left: 65px">
        <a><img src="../../../assets/images/partnerlogo/23.png"></a>
      </div>
      <div style="padding-left: 64px">
        <a><img src="../../../assets/images/partnerlogo/24.png"></a>
      </div>
      <div style="padding-left: 65px">
        <a><img src="../../../assets/images/partnerlogo/25.png"></a>
      </div>
      <div style="padding-left: 65px">
        <a><img src="../../../assets/images/partnerlogo/26.png"></a>
      </div>
      <div style="padding-left: 77px">
        <a><img src="../../../assets/images/partnerlogo/27.png"></a>
      </div>
      <div style="padding-left: 78px">
        <a><img src="../../../assets/images/partnerlogo/28.png"></a>
      </div>
    </div> -->
    <!-- <div class="row part_top_padding">
      <div style="padding-top: 14px">
        <a><img src="../../../assets/images/partnerlogo/29.png"></a>
      </div>
      <div style="padding: 17px 0px 0px 29px">
        <a><img src="../../../assets/images/partnerlogo/30.png"></a>
      </div>
      <div style="padding:21px 0px 0px 29px">
        <a><img src="../../../assets/images/partnerlogo/31.png"></a>
      </div>
      <div style="padding-left: 48px">
        <a><img src="../../../assets/images/partnerlogo/32.png"></a>
      </div>
      <div style="padding: 22px 0px 0px 52px">
        <a><img src="../../../assets/images/partnerlogo/33.png"></a>
      </div>
      <div style="padding-left: 53px">
        <a><img src="../../../assets/images/partnerlogo/34.png"></a>
      </div>
      <div style="padding:19px 0px 0px 53px ">
        <a><img src="../../../assets/images/partnerlogo/35.png"></a>
      </div>
    </div> -->
     
      <div class="img1class">
        <img src="../../../assets/images/zongce/16.jpg"/>
      </div>
  </div>
  
</template>

<script>
  import partnerpartcontent from "@/components/contentcoms/indexcontentcoms/partnerpartcontent";
  export default {
      name: "cooperationcontent",
      components: {partnerpartcontent}
  }
</script>

<style scoped>
  .part_top_padding{
    padding-top: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/components/contentcoms/cooperationcontentcoms/cooperationcontent.vue